import { useContext } from 'react';
import Link from '@/helpers/Link';
import { useRouter } from 'next/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { modalContext } from '@/context/modal.context';
import { AccountContext } from '@/context/account.context';
import { SolutionContext } from '@/context/solution.context';
import Button from '@/components/Button/Button';
import publicRoutes from '@/public-routes.json';

const LoginButtons = ({ t, classes, mobile, onCloseMenu }) => {
  const router = useRouter();
  const { solution } = useContext(SolutionContext);
  const { enqueueModal } = useContext(modalContext);
  const { isLoggedIn } = useContext(AccountContext);

  const onAnAuthPage = publicRoutes.loginRoutes.includes(router.pathname.split('/')[1]);
  const allowLogin = solution.includes?.log_in;
  const allowSignup = solution.includes?.sign_up;

  const showLogin = allowLogin && !onAnAuthPage;
  const showSignup = allowSignup && !onAnAuthPage;

  const openSignup = () => {
    onCloseMenu();
    enqueueModal({ name: 'SignupModal' });
  };

  const openLogin = () => {
    onCloseMenu();
    enqueueModal({ name: 'LoginModal' });
  };

  if (isLoggedIn || onAnAuthPage) {
    return null;
  }

  if (mobile) {
    return (
      <ul>
        {showSignup && (
          <li key="signup">
            <button data-cy="mobile-drawer-link-signup" onClick={openSignup}>
              <FontAwesomeIcon icon={['fa', 'check']} aria-hidden="true" /> &nbsp;
              {t('Sign up')}
            </button>
          </li>
        )}
        {showLogin && (
          <li key="login">
            <button data-cy="mobile-drawer-link-login" onClick={openLogin}>
              <FontAwesomeIcon icon={['fa', 'sign-in-alt']} aria-hidden="true" /> &nbsp;
              {t('Log in')}
            </button>
          </li>
        )}
        <li onClick={onCloseMenu} key="assessments">
          <Link href="/plan#assessments">
            <span>
              <FontAwesomeIcon icon={['fa', 'paste']} aria-hidden="true" /> &nbsp;
              {t('Assessments')}
            </span>
          </Link>
        </li>
      </ul>
    );
  } else {
    if (!showLogin && !showSignup) return null;
    const showBoth = showLogin && showSignup;
    return (
      <div className={`btn-group ${classes.desktopAuthBtns}`}>
        {showLogin && (
          <Button
            key="login"
            type="default"
            shape="pill"
            groupPosition={showBoth ? 'left' : ''}
            dataCy={'header-btn-login'}
            additionalClasses={`${classes.headerBtn} ${classes.left}`}
            onButtonClick={openLogin}
            text={t('Login')}
            styles={{ font: 'bold' }}
          />
        )}
        {showSignup && (
          <Button
            key="signup"
            type="default"
            shape="pill"
            groupPosition={showBoth ? 'right' : ''}
            dataCy={'header-btn-sign-up'}
            additionalClasses={classes.headerBtn}
            onButtonClick={openSignup}
            text={t('Sign up')}
            styles={{ font: 'bold' }}
          />
        )}
      </div>
    );
  }
};

export default LoginButtons;
